import Swal from "sweetalert2";
import { ErrorToastContainer } from "../whatsapp/function/CustomFunction";
import domain from "../reusecomponent/domain";
import Swalaleart from "../whatsapp/function/swalaleart";
import { getToken } from "../whatsapp/function/token";

let client = null;

export function startGoogleAuth(setLoading,setOpen,dataRef) {
  setLoading(true);

  if (window.google && window.google.accounts) {
    initClient(setLoading,setOpen,dataRef);
    return;
  }

  const script = document.createElement("script");
  script.src = "https://accounts.google.com/gsi/client";
  script.async = true;
  script.defer = true;

  script.onload = () => {
    initClient(setLoading,setOpen,dataRef);
  };

  script.onerror = () => {
    console.error("Google script failed to load");
    setLoading(false);
  };

  document.body.appendChild(script);
}

function initClient(setLoading,setOpen,dataRef) {
  client = window.google.accounts.oauth2.initCodeClient({
    client_id: process.env.REACT_APP_CLIENT_ID,
    scope: "https://www.googleapis.com/auth/business.manage",
    ux_mode: "popup",
    callback: (response) => {
      setLoading(false);

      if (response.code) {
          Swal.fire({
            title: "Succes",
            text: "Please Wait Some Time",
            icon: "success",
            showConfirmButton: false,
            timer: 1500
          }).then(async () => {
            setLoading(true);
             console.log(response.code);
            try{
              
              const myHeaders = new Headers();
              const formdata = new FormData();
              const access_token = getToken();
              
              myHeaders.append(`Authorization`, `Bearer ${access_token}`);
              formdata.append("auth_code",btoa(response.code));

              const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
              };
              const res = await fetch(`${domain()}/gmb/gmb_auth`, requestOptions)
              const result = await res.json();

              if(result.status){
                dataRef.current = result.data;
                setLoading(false);
                Swal.fire({
                  title: "Succes",
                  text: "Google My Business Authenticated Successfully",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1500
                })
                setTimeout(() => {
                  setOpen(true);
                }, 1500);
              } else {
                console.log(result.data);
                setLoading(false);
                Swalaleart({title: "Error",text: result.message || "Something Went Wrong",icon: "error",});
              }

            }catch(error){
              setLoading(false);
              Swalaleart({title: "Error",text: "Network Error",icon: "error",});
            }

          })
      } else {
        ErrorToastContainer("Authentication was not completed.");
      }
    },
    error_callback: (error) => {
      setLoading(false);
      ErrorToastContainer(error.message);
    }
  });

  client.requestCode();
}
